import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  volume_ml: z.number().int().positive().optional(),
  longevity_hours: z.number().int().positive().optional(),
  sillage: z.enum(["Intimate", "Moderate", "Strong", "Enormous"]).optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "personal-perfumes",
    slug: "personal-perfumes",
    name: "Personal Perfumes",
    tagline: "House compositions for skin",
    status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name", "family", "notes"], attributes: [] },
  facets: [
    { key: "family",        label: "Family",        type: "enum", source: "column",
      options: ["Floral","Oriental","Woody","Leather","Chypre","Amber","Green"] },
    { key: "gender",        label: "Gender",        type: "enum", source: "column",
      options: ["Feminine","Masculine","Unisex"] },
    { key: "concentration", label: "Concentration", type: "enum", source: "column",
      options: ["EDT","EDP","Parfum","Extrait"] },
    { key: "price",         label: "Price (₹)",     type: "range", source: "column",
      min: 100, max: 500, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "details", label: "Fragrance details", attributes: ["volume_ml","longevity_hours","sillage"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Perfume",
    descriptionTemplate: "{name} — a CB16 signature perfume for personal wear.",
    routePrefix: "personal-perfumes",
  },
  adminForm: [
    { key: "volume_ml",       label: "Volume (ml)",       kind: "number" },
    { key: "longevity_hours", label: "Longevity (hours)", kind: "number" },
    { key: "sillage",         label: "Sillage",           kind: "select",
      options: ["Intimate","Moderate","Strong","Enormous"] },
  ],
};
